/* eslint-disable camelcase */
export const DEFAULTS = {
  config: { alignment: 'center', size: 'content' },
  configViewer: {
    downloadTarget: '_blank',
  },
};
